function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "noun-java-903471");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "noun-java-903471",
  transform: "translate(0.670000, -0.002000)",
  fill: "#FFFFFF",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "373.33 373.332 56 373.332 56 168.002 373.33 168.002 373.33 112.002 261.33 112.002 261.33 0.002 -2.84217094e-14 0.002 -2.84217094e-14 448.002 373.33 448.002"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "280 93.332 373.332 93.332 280 -2.84217094e-14"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "410.66 242.672 429.328 242.672 429.328 261.34 410.66 261.34"
}), /*#__PURE__*/React.createElement("path", {
  d: "M485.33,354.672 L485.33,186.672 L74.66,186.672 L74.66,354.672 L485.33,354.672 Z M391.998,224.002 L447.998,224.002 L447.998,317.334 L429.33,317.334 L429.33,280.002 L410.662,280.002 L410.662,317.334 L391.994,317.334 L391.998,224.002 Z M130.658,317.334 L111.99,317.334 L111.99,298.666 L130.658,298.666 L130.658,317.334 Z M205.326,242.67 L186.658,242.67 L186.658,317.338 L149.326,317.338 L149.326,298.67 L167.994,298.67 L167.994,242.67 L149.326,242.67 L149.326,224.002 L205.326,224.002 L205.326,242.67 Z M279.994,317.334 L261.326,317.334 L261.326,280.002 L242.658,280.002 L242.658,317.334 L223.99,317.334 L223.99,224.002 L279.99,224.002 L279.994,317.334 Z M354.658,317.334 L335.99,317.334 L335.99,298.666 L317.322,298.666 L317.322,279.998 L298.654,279.998 L298.654,223.998 L317.322,223.998 L317.322,279.998 L354.658,279.998 L354.658,223.998 L373.326,223.998 L373.326,279.998 L354.658,279.998 L354.658,317.334 Z",
  id: "Shape"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "242.66 242.672 261.328 242.672 261.328 261.34 242.66 261.34"
})));

var SvgJava = function SvgJava(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "486px",
    height: "448px",
    viewBox: "0 0 486 448",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJava, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Java.178a070a.svg";
export { ForwardRef as ReactComponent };